<template>
  <div
    class="form-group"
    :class="{
      'input-group-focus': focused,
      'has-danger': error,
      'has-success': !error && touched,
      'has-label': label,
      'has-icon': hasIcon,
    }"
  >
    <slot name="label">
      <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
    </slot>
    <div class="mb-0" :class="{'input-group': hasIcon}">
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon"></i></div>
        </span>
      </slot>
      <slot>
        <template class=""  v-if="type=='regular'">
          <input 
            :pattern="pattern"
            :value="value"
            v-bind="$attrs"
            v-on="listeners"
            class="form-control mb-3"
            aria-describedby="addon-right addon-left"
          />
        </template>
        <template class="" v-if="type=='datetimelocal'">
          <input 
            :pattern="pattern"
            :value="value"
            v-bind="$attrs"
            v-on="listeners"
            type="datetime-local"
            placeholder="дд.мм.гггг --:--"
            class="form-control"
            aria-describedby="addon-right addon-left"
            max="9999-12-31T23:59"
          />
          <!-- <span class="el-input__prefix" style="z-index: 1;"><i class="el-input__icon el-icon-date"></i></span> -->
        </template>
        <template class="" v-if="type=='date'">
          <input 
            :pattern="pattern"
            :value="value"
            v-bind="$attrs"
            v-on="listeners"
            type="date"
            placeholder="дд.мм.гггг"
            class="form-control"
            aria-describedby="addon-right addon-left"
            max="9999-12-31"
          />
        </template>
        <template class="" v-if="type=='time'">
          <input 
            :pattern="pattern"
            :value="value"
            v-bind="$attrs"
            v-on="listeners"
            type="time"
            placeholder="--:--"
            class="form-control"
            aria-describedby="addon-right addon-left"
            max="23:59"
          />
          <!-- <span class="el-input__prefix" style="z-index: 1;"><i class="el-input__icon el-icon-date"></i></span> -->
        </template>
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <div class="input-group-text"><i :class="addonRightIcon"></i></div>
        </span>
      </slot>
    </div>

    <slot name="error" v-if="error || $slots.error">
      <label class="error">{{ error }}</label>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
// import Cleave from 'cleave.js';
// import cleavePhoneI18n from 'cleave.js/dist/addons/cleave-phone.i18n';

export default {
  inheritAttrs: false,
  name: 'base-date-time-picker',
  props: {
    required: Boolean,
    type: {
      type: String,
      description: 'Input type',
      default: ''
    },
    label: {
      type: String,
      description: 'Input label'
    },
    error: {
      type: String,
      description: 'Input error',
      default: ''
    },
    value: {
      type: [String, Number],
      description: 'Input value',
      default: ''
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right'
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left'
    },
    pattern: {
      type: String,
      description: 'Input pattern',
      default: ''
    },
    daterestriction: {
      type: String,
      default: '' //today, tomorrow
    },
    min:{
      type: String,
      default: ''
    },
    max:{
      type: String,
      default: ''
    },
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      focused: false,
      touched: false,
      bufferValue: '',
    };
  },
  watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(this.$GVO.str_replace('T',' ',val));
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},

		},
  computed: {
    hasIcon() {
      return this.hasLeftAddon || this.hasRightAddon
    },
    hasLeftAddon() {
      const { addonLeft } = this.$slots;
      return (
        addonLeft !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    hasRightAddon() {
      const { addonRight } = this.$slots;
      return (
        addonRight !== undefined ||
        this.addonRightIcon !== undefined
      );
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      };
    }
  },
  methods: {
    onInput(evt) {
      if (!this.touched) {
        this.touched = true;
      }
      this.$emit('input', evt.target.value);
    },
    onFocus(evt) {
      this.focused = true;
      this.$emit('focus', evt)
    },
    onBlur(evt) {
      this.focused = false;
      this.$emit('blur', evt)
    },
    getRestrictions(){
      const today=(new Date()).toLocaleDateString("EN-CA").slice(0,10); // get local current date //toISOString вместо toLocaleDateString, чтобы браузер принимал формат
      const tomorrow = new Date(+new Date().setHours(0, 0, 0,0)+ 86400000).toLocaleDateString('EN-CA');  //toISOString вместо toLocaleDateString, чтобы браузер принимал формат
      const dateInput = document.querySelector('input[type="datetime-local"]');
      
      if(this.daterestriction == 'today'){
        // document.querySelectorAll('input[type="datetime-local"]').forEach(el=>{el.min=today+"T00:00";});
        dateInput.min=today+"T00:00"; //dateInput.max=today+"T23:59";

      } else if (this.daterestriction == 'tomorrow'){
        dateInput.min=tomorrow+"T00:00"; 
      } else {

      }
      
    },
    delTimeFromDateValues(){
      if(this.type == 'date' && (this.value !='' && this.value!= undefined && this.value.includes(' ')) ){
        this.bufferValue = this.value.slice(0, this.value.indexOf(' ')); // это для старых значений старого календаря. Если вренемся к календарю темы, то это закоментить. Оно удаляет лишние 00:00:00 времени 
        // console.log(this.bufferValue);
        // this.value = newvalue;
      }else if (this.type == 'date' && this.value == '0000-00-00'){
        // this.value = '1990-01-01';
        this.bufferValue = '';
      }
    }
  },
  directives: {
        // cleave: {
        //     inserted: (el, binding) => {
        //         el.cleave = new Cleave(el, binding.value || {})
        //     },
        //     update: (el) => {
        //         const event = new Event('input', {bubbles: true});
        //         setTimeout(function () {
        //             el.value = el.cleave.properties.result
        //             el.dispatchEvent(event)
        //         }, 100);
        //     }
        // }
  },
	mounted() {
    this.delTimeFromDateValues();
		this.getRestrictions();
	}
};
</script>
<style scoped>

input::-webkit-calendar-picker-indicator:hover {cursor: pointer;}
input::-webkit-calendar-picker-indicator {position: absolute;font-size: .9rem; opacity: 0.6;}
input::-webkit-datetime-edit {padding-left: 25px;}

/* @media (max-width: 400px){
  input[type="datetime-local"]:not(.has-value):before{
    color: lightgray;
    content: attr(placeholder);
  }
} */

/*  */


</style>
